var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgButtonIconNormal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0683 19.9892L23.1163 11.2439C23.4436 10.9187 23.9744 10.9187 24.3018 11.2439C24.6292 11.5692 24.6292 12.0966 24.3018 12.4218L14.6611 21.7561C14.3337 22.0813 13.8029 22.0813 13.4756 21.7561L8.7929 17.0027C8.46552 16.6774 8.46552 16.1501 8.7929 15.8248C9.12029 15.4995 9.65108 15.4995 9.97846 15.8248L14.0683 19.9892Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgButtonIconNormal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ButtonIconNormal.23022da552e40a43015236e4882038f8.svg";